import React, { useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import "./RequestForm.css";
import ConfirmationModal from "../../../components/common/ConfirmModal";
import { adminRequestFundLoad } from "../../../config/LiveApi";
import Select from "react-select";

function RequestForm() {
  const token = useSelector((store) => store.userReducer.token);

  const [formData, setFormData] = useState({
    depositAmount: "",
    utr: "",
    remark: "",
    paymentMode: null,
  });

  const [loading, setLoading] = useState(false);
  const [isConfirmModal, setIsConfirmModal] = useState({
    isOpen: false,
    onResolve: null,
  });

  const handleInputChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.depositAmount || !formData.utr || !formData.paymentMode) {
      toast.error("Please fill all required fields correctly.");
      return;
    }

    const userConfirmed = await openConfirmation();
    if (!userConfirmed) return;

    setLoading(true);

    try {
      const payload = {
        ...formData,
        paymentMode: formData.paymentMode.value,
      };

      const response = await adminRequestFundLoad(token, payload);
      toast.success(response.message);

      setFormData({
        depositAmount: "",
        utr: "",
        remark: "",
        paymentMode: null,
      });
    } catch (err) {
      toast.error("Submission failed.");
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const openConfirmation = () => {
    return new Promise((resolve) => {
      setIsConfirmModal({
        isOpen: true,
        onResolve: resolve,
      });
    });
  };

  const options = [
    { value: "IMPS", label: "IMPS" },
    { value: "NEFT", label: "NEFT" },
    { value: "RTGS", label: "RTGS" },
    { value: "OTHER", label: "OTHER" },
  ];

  return (
    <div className="formrequest-wallet-container">
      <h2 className="formrequest-title">Wallet Upload</h2>
      <form className="wallet-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Deposit Amount</label>
          <input
            type="number"
            placeholder="Enter deposit amount"
            className="form-input"
            value={formData.depositAmount}
            onChange={(e) => handleInputChange("depositAmount", e.target.value)}
            min="1"
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">UTR</label>
          <input
            type="text"
            placeholder="Enter UTR"
            className="form-input"
            value={formData.utr}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                handleInputChange("utr", value);
              }
            }}
            required
            pattern="^\d{12,16}$"
            title="UTR must be 12 to 16 digits"
            maxLength="16"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Payment Mode</label>
          <Select
            options={options}
            required
            isSearchable={true}
            value={formData.paymentMode}
            onChange={(selectedOption) =>
              handleInputChange("paymentMode", selectedOption)
            }
            placeholder="Select Mode of Payment"
            className="form-select-mode"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Remarks</label>
          <input
            type="text"
            placeholder="Enter remarks"
            className="form-input"
            value={formData.remark}
            required
            onChange={(e) => handleInputChange("remark", e.target.value)}
          />
        </div>

        <div className="form-group">
          <button
            type="submit"
            className="fund-load-submit-button"
            disabled={loading}
          >
            {loading ? <div className="fund-load-loader"></div> : "Submit"}
          </button>
        </div>
      </form>

      {isConfirmModal.isOpen && (
        <ConfirmationModal
          onResolve={(decision) => {
            if (typeof isConfirmModal.onResolve === "function") {
              isConfirmModal.onResolve(decision);
            }
            setIsConfirmModal({ isOpen: false, onResolve: null });
          }}
        />
      )}
    </div>
  );
}

export default RequestForm;
